import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DeviceService } from '@shared/services';

@Component({
  selector: 'sd-login-button',
  templateUrl: './login-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoginButtonComponent {
  constructor(public deviceService: DeviceService) {}
}
